module.exports = __webpack_public_path__ + "static/media/general-service-white.627d192e.png";